import type { UiKey } from "../i18n/ui";
import { COEFFICIENTS_LAST_UPDATED, REFERENCE_LINKS } from "../lib/modelMeta";

type Props = { t: (key: UiKey) => string };

export function TrustPanel({ t }: Props) {
  return (
    <div className="trust-panel">
      <h2>{t("trust.panelTitle")}</h2>
      <p className="lead">{t("trust.panelLead")}</p>
      <p className="coeff">
        <strong>{t("trust.coefficientsLabel")}:</strong> {COEFFICIENTS_LAST_UPDATED}
      </p>
      <ul className="links">
        {REFERENCE_LINKS.map((r) => (
          <li key={r.href}>
            <a href={r.href} target="_blank" rel="noopener noreferrer">
              {t(r.labelKey)}
            </a>
          </li>
        ))}
      </ul>
      <style>{`
        .trust-panel {
          padding: 0.85rem 1rem;
          border-radius: 10px;
          border: 1px solid var(--border);
          background: var(--surface2);
        }
        .trust-panel h2 {
          font-size: 0.95rem;
          margin: 0 0 0.4rem;
        }
        .lead {
          margin: 0 0 0.5rem;
          font-size: 0.82rem;
          color: var(--muted);
          line-height: 1.45;
        }
        .coeff {
          margin: 0 0 0.45rem;
          font-size: 0.8rem;
          color: var(--text);
        }
        .links {
          margin: 0;
          padding-left: 1.1rem;
          font-size: 0.8rem;
          line-height: 1.5;
        }
        .links a {
          color: var(--accent);
        }
      `}</style>
    </div>
  );
}
